import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import SliderPanel from "../../BaseLayout/SliderPanel.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import AppStrategicAssociationsIcon from "../../../media/app-images/AppStrategicAssociationsIcon.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import AppSynthDataIcon from "../../../media/app-images/AppSynthDataIcon.mjs";
import MySelect from "../../../controls/MySelect/MySelect.mjs";
import {Form, InputGroup, InputGroupText, Label} from "reactstrap";
import AssociazioniStrategicheSoggetto from "../../../ComponentParts/AssociazioniStrategiche/AssociazioniStrategicheSoggetto.mjs";

const prefix = "StrategicAssociations";

const StrategicAssociations = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: Glob.getLanguage(),
			ll: Glob.getLanguageLong()
		};
		this.uid = Glob.generateUid(prefix);
		this.loadPerimetri = this.loadPerimetri.bind(this);
		this.loadAssociazioni = this.loadAssociazioni.bind(this);
		this.strategicAssociations = this.strategicAssociations.bind(this);
	}
	componentDidMount() {
		Glob.setStatus('pageTitle', ["Perimeters",prefix]);
		Glob.setStatus('pageIcon', <AppPerimeterIcon/>);
		Glob.register('Prefs', ()=>{
			this.setState({ lang: Glob.getLanguage(), ll: Glob.getLanguageLong() });
		}, this.uid );
		setTimeout( this.loadPerimetri );
	}
	componentWillUnmount() {
		Glob.deregister( this.uid );
	}
	loadPerimetri() {
		appLib.api('perimetri/list').then( l => {
			if ( ! Array.isArray(l?.list) ) return;
			const list = l.list
				.sort((a,b) => a.name.toLocaleLowerCase(this.state.ll).localeCompare(b.name.toLocaleLowerCase(this.state.ll)))
				.map( p => ({value: p.id, name: p.name, label: <>{p.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon />}<span>“{p.name}”</span></> }));
			this.setState({ perimetri: list });
		})
	}
	async loadAssociazioni() {
		if ( ! this.state.perimetro?.value ) {
			this.setState({ associazioni: [], updateAssociazioni: Date.now() });
			return;
		}
		const data = await appLib.api('simul/get-associazioni',  { peri: this.state.perimetro.value });
		this.setState({ associazioni: data, updateAssociazioni: Date.now() });
	}
	setAssociazione( id, value ) {
		value = (value||[]).filter( x => !! x?.item );
		appLib.api("perimetri/set-associazione", { asso: { id: id, value: value} }).then( this.loadAssociazioni );
	}
	strategicAssociations() {
		if ( ! this.state.associazioni ) return null;
		const ass = [];
		Object.entries(this.state.associazioni).forEach(([key, value]) => {
			const e = structuredClone(value);
			e.id = key;
			ass.push(e);
		});
		if ( ! ass.length ) return null;
		ass.sort((a, b) => ( a.name.localeCompare( b.name )));
		return (
			<div
				key={this.state.updateAssociazioni}
				className={prefix + "-card"}
			>
				<h5 className={"text-center"}>
					{ this.state.lang === 'it' ? 'Associazioni per il modello strategico' : 'Strategic model associations' }
				</h5>
				<div className={"associazioni"}>
					{ ass.map( a => (
						<AssociazioniStrategicheSoggetto
							key={a.id}
							asso={a}
							save={ v => { this.setAssociazione( a.id, v )}}
						/>
					))}
				</div>
			</div>
		)
	}
	render() {
		return (
			<SliderPanel
				title={<TextLabel value={prefix} /> }
				className={prefix}
				icon={<AppStrategicAssociationsIcon />}
			>
				{ this.state.lang ==='it' ? (
					<div>
						In questo pannello viene curata l’associazione tra i soggetti presenti nei diversi perimetri e gli item del modello strategico.<br />
						Ogni soggetto può essere associato a uno o più item del modello strategico, con un “peso” percentuale relativo in seno all’item.
					</div>
				) : (
					<div>
						This panel manages association between different subjects in perimeters and strategic model items.<br />
						Each subject can be associated to one or more items, with a different percentual “weight” within each item.
					</div>
				)}
				{ ( !! this.state.perimetri) && (
					<div style={{maxWidth:"800px",margin: "1rem auto"}}>
						<Form>
							<InputGroup>
								<InputGroupText>
									<Label>
										<TextLabel value={"Perimeter"} />:
									</Label>
								</InputGroupText>
								<div className={"flex-grow-1"}>
									<MySelect
										placeholder={ Glob.label('Select')}
										options={ this.state.perimetri }
										isClearable={true}
										onChange={ l => {
											this.setState({perimetro: l}, this.loadAssociazioni)
										} }
									/>
								</div>
							</InputGroup>
						</Form>
					</div>
				)}
				{ this.strategicAssociations() }
			</SliderPanel>
		)
	}
}

export default StrategicAssociations;